//@flow
import * as React from 'react';
import type { StatelessFunctionalComponent } from 'react';
import { I18nextProvider } from 'react-i18next';
import type { I18nextProviderProps } from 'react-i18next';
import i18next from './i18next';

export type LocaleModule = {
    ns: string,
    resources: any
};

type Props = {
    modules: Array<LocaleModule>,
    config: any,
    CustomProvider?: StatelessFunctionalComponent<I18nextProviderProps>
};

export const LocaleProvider = ({
    modules,
    config,
    CustomProvider,
    ...rest
}: Props) =>
    // TODO: Temporary solution to apply legacy i18next FS-221
    CustomProvider ? (
        <CustomProvider {...rest} i18n={i18next(modules, config)} />
    ) : (
        <I18nextProvider {...rest} i18n={i18next(modules, config)} />
    );
